import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import '../../css/Login.css';

const LoginSection = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const savedPhone = localStorage.getItem('savedPhone');
    if (savedPhone) setPhone(savedPhone);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await api.post('/employee-login', {
        phone,
        password,
      });

      // Check if login is successful by checking the presence of token and employee details
      if (response.data && response.data.access_token && response.data.employee) {
        const { access_token, employee } = response.data;

        // Save the employee ID and token in localStorage
        localStorage.setItem('authToken', access_token);
        localStorage.setItem('emp_id', employee.phone); // Using phone as emp_id
        localStorage.setItem('savedPhone', phone);
        localStorage.setItem('currentRole', 'user'); // Role of user

        // Navigate to the dashboard or next page
        setIsLoggedIn(true);
        navigate('/employee-attendance');
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      console.error(err);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <section className="section-login">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <form onSubmit={handleSubmit}>
              <div className='content-wrapper'>
                <div className='img-box'>
                  <img src="./images/site-logo.png" alt="Site Logo" />
                </div>
                <h2>Login</h2>
                {error && <p className="error-message">{error}</p>}
                <div className='form-box'>
                  <div className="form-group">
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Phone number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group password-wrapper">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      name="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span onClick={togglePasswordVisibility}>
                      {showPassword ? '🙈' : '👁️'}
                    </span>
                  </div>
                  <button type="submit">Login</button>
                </div>
              </div>
            </form>
          </div>
          <div className="right-wrapper">
            <img src="./images/h2.jpg" alt="Login Visual" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginSection;
